import { generateSkinDefaults } from '@wix/editor-elements-panel';

import type { SiteAssetsSkinParams } from '../TextEffectsShared/TextEffectsShared.skinParams';
import { textEffectsSharedSkin } from '../TextEffectsShared/TextEffectsShared.skinParams';

export const TextEffectsMatrixSkin = {
  ...textEffectsSharedSkin,
  'text-effects-color-1': {
    type: 'COLOR',
    defaultValue: '#000000',
  },
  'inner-animation-speed': {
    type: 'ALPHA',
    defaultValue: '12.6',
  },
  'disable-inner-animation': {
    type: 'CSSString',
  },
  'mask-position': {
    type: 'NUMBER',
  },
  'text-blur': {
    type: 'NUMBER',
    defaultValue: '0',
  },
  'mask-blur': {
    type: 'NUMBER',
    defaultValue: '0',
  },
} as const satisfies SiteAssetsSkinParams;

const TextEffectsMatrixSkinDefinitionMap: Record<string, SiteAssetsSkinParams> =
  {
    'wixui.skins.TextEffectsMatrix': TextEffectsMatrixSkin,
  };

export default generateSkinDefaults(TextEffectsMatrixSkinDefinitionMap);
